import styled, { Spacing, BorderRadius, Font } from '@nfinite/react-hubstairs/styled'

import RoundPicture from 'components/Commons/RoundPicture'

const USER_PICTURE_SIZE = 50

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  ${Spacing.generatePadding({ vertical: 'l', horizontal: 'xl' })}
`

export const User = styled(RoundPicture)`
  width: ${USER_PICTURE_SIZE}px;
  height: ${USER_PICTURE_SIZE}px;
  border: none;
  ${BorderRadius.generate({ all: 'round' })}
  background-color: transparent;
`

export const Row = styled('div')`
  display: flex;
  align-items: center;
  gap: ${Spacing.get('xs')}px;
`

export const Column = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.get('xxs')}px;
`

export const Title = styled('div')`
  ${Font.generate({ size: 'm', weight: 'bolder' })}
`
export const SubTitle = styled('div')``
